/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseComponent from '@tock/shared/components/BaseComponent';
import connect from 'utils/connect';

class LogoutRoute extends BaseComponent<any> {
  componentDidMount() {
    this.props.actions.app.logout();
    this.props.history.push('/login');
    window.location.reload();
  }

  render() {
    return null;
  }
}

export default connect<any, any>(LogoutRoute);
